import React from 'react';

export function SettingsIcon({ className, width = 20, height = 20 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5079_2882)">
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3518 8.66316L15.4371 6.45432L16.6665 5.00033L14.9998 3.33366L13.5538 4.56945L11.298 3.64177L10.7793 1.66699H9.15065L8.62407 3.66793L6.42018 4.59696L4.99984 3.33366L3.33317 5.00033L4.54431 6.49103L3.64359 8.7056L1.6665 9.16699V10.8337L3.66743 11.3799L4.59629 13.5834L3.33317 15.0003L4.99984 16.667L6.49247 15.4506L8.66402 16.3439L9.1665 18.3337H10.8332L11.3369 16.3446L13.5458 15.4299C13.9139 15.6931 14.9998 16.667 14.9998 16.667L16.6665 15.0003L15.4298 13.5415L16.3447 11.332L18.3331 10.8146L18.3332 9.16699L16.3518 8.66316Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5079_2882">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
